import { useCallback, useEffect, useState } from 'react'

export interface UseCountdownOverlay {
  isVisible: boolean
  secondsRemaining: number
  start: () => void
}

export const useCountdownOverlay = (durationSeconds: number, isFetching: boolean): UseCountdownOverlay => {
  const [isActive, setIsActive] = useState(false)
  const [secondsRemaining, setSecondsRemaining] = useState(durationSeconds)

  const countdownDone = secondsRemaining <= 0

  const start = useCallback(() => {
    setSecondsRemaining(durationSeconds)
    setIsActive(true)
  }, [durationSeconds])

  useEffect(() => {
    if (!isActive || countdownDone) return

    const id = window.setInterval(() => {
      setSecondsRemaining((s) => Math.max(0, s - 1))
    }, 1000)

    return () => window.clearInterval(id)
  }, [isActive, countdownDone])

  useEffect(() => {
    if (isActive && countdownDone && !isFetching) {
      setIsActive(false)
    }
  }, [isActive, countdownDone, isFetching])

  return {
    isVisible: isActive,
    secondsRemaining: Math.max(secondsRemaining, 0),
    start,
  }
}
